"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-unused-vars
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
// eslint-disable-next-line no-unused-vars
const floating_vue_1 = require("floating-vue");
// eslint-disable-next-line no-unused-vars
const CropSwitcher_vue_1 = __importDefault(require("@becrop/components/Modules/Common/Components/CropSwitcher.vue"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let SidebarTracking = class SidebarTracking extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.sidebar_selected = 'home';
        // MixPanel init
        this.mixpanelHandler = new MixpanelHandler_1.default();
    }
    get entities() {
        return ['areas', 'projects', 'deliverables', 'blocks', 'reports'];
    }
    get urlLibrary() {
        return [
            {
                item: 'home',
                url: '/results/reports',
            },
            {
                item: 'map',
                url: '/results/map',
            },
            {
                item: 'result',
                url: '/results/map',
            },
            {
                item: 'projects',
                url: '',
            },
            {
                item: 'deliverables',
                url: '/results/projects',
            },
            {
                item: 'areas',
                url: '/results/projects',
            },
            {
                item: 'parcels',
                url: '/results/projects',
            },
            {
                item: 'reports',
                url: '/results/projects',
            },
            {
                item: 'toolkit',
                url: '',
            },
            {
                item: 'support',
                url: '/results/support',
            },
        ];
    }
    // eslint-disable-next-line camelcase
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    sidebarItemClicked(item) {
        const currItem = this.urlLibrary.find((lib) => lib.item === item);
        if (currItem.url.length > 0) {
            window.location.href = currItem.url;
        }
        this.sidebarItemClickedMixPanel(item);
    }
    sidebarItemClickedMixPanel(item) {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('sidebarItemClicked', {
            origin: originModule,
            navItem: item,
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], SidebarTracking.prototype, "crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], SidebarTracking.prototype, "crop", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SidebarTracking.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SidebarTracking.prototype, "sidebar_selected", void 0);
SidebarTracking = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'SidebarTracking',
        components: {
            Sidebar: bmk_ui_framework_1.Sidebar,
            ModuleSwitcher: bmk_ui_framework_1.ModuleSwitcher,
            SidebarItem: bmk_ui_framework_1.SidebarItem,
            SidebarNavigation: bmk_ui_framework_1.SidebarNavigation,
            ProjectMiniGrid: bmk_ui_framework_1.ProjectMiniGrid,
            Dropdown: floating_vue_1.Dropdown,
            PlusIcon: bmk_ui_framework_1.PlusIcon,
            Chart3: bmk_ui_framework_1.Chart3,
            PinIcon: bmk_ui_framework_1.PinIcon,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            FolderIcon: bmk_ui_framework_1.FolderIcon,
            ToolboxIcon: bmk_ui_framework_1.ToolboxIcon,
            SupportIcon: bmk_ui_framework_1.SupportIcon,
            LandscapeIcon: bmk_ui_framework_1.LandscapeIcon,
            ParcelsIcon: bmk_ui_framework_1.ParcelsIcon,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            BlobsIcon: bmk_ui_framework_1.BlobsIcon,
            BoxPlotIcon: bmk_ui_framework_1.BoxPlotIcon,
            HeatmapIcon: bmk_ui_framework_1.HeatmapIcon,
            Tag: bmk_ui_framework_1.Tag,
            CropSwitcher: CropSwitcher_vue_1.default,
        },
    })
    // eslint-disable-next-line no-unused-vars
], SidebarTracking);
exports.default = SidebarTracking;
